import type { MODULATORS_CONSUMPTIONS_CHART_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/modulators-consumptions-chart-card/modulators-consumptions-chart-card.fr.ts";

export const MODULATORS_CONSUMPTIONS_CHART_CARD_ENGLISH_LOCALE = {
  title: "Consumption",
} satisfies typeof MODULATORS_CONSUMPTIONS_CHART_CARD_FRENCH_LOCALE;
